'use client';

import dynamic from 'next/dynamic';

import { OWallboxConfiguratorType } from '../../types/storyblok';

export const OWallboxConfigurator = dynamic<OWallboxConfiguratorType>(() => import('./OWallboxConfigurator'), {
  ssr: true,
});
